<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.006" viewBox="0 0 20 20.006">
        <path id="Caminho_10489" data-name="Caminho 10489" d="M18.605.1.5,10.542A.938.938,0,0,0,.584,12.23l4.153,1.742L15.961,4.08A.234.234,0,0,1,16.3,4.4L6.885,15.871v3.145a.937.937,0,0,0,1.66.617l2.481-3.02,4.868,2.039a.94.94,0,0,0,1.289-.711L20,1.064A.938.938,0,0,0,18.605.1Z" transform="translate(-0.01 0.031)" fill="#081D38"/>
    </svg>
</template>
